/** Meta campaign statuses that can't take new ads. */
export const CLOSED_CAMPAIGN_STATUSES = ["DELETED", "ARCHIVED"];

/** Meta campaign statuses that get a tag on the mapping. */
export const TAGGED_CAMPAIGN_STATUSES = [
  "ACTIVE",
  "PAUSED",
  "ARCHIVED",
  "DELETED",
];

/** Columns of the combined track + campaign upload, in template order. */
export const CTM_IMPORT_COLUMNS = [
  { key: "app_name", label: "App", aliases: ["app", "app name", "app_name"] },
  { key: "language", label: "Language", aliases: ["language", "lang"] },
  {
    key: "category",
    label: "Category",
    aliases: ["category", "category name"],
  },
  { key: "track", label: "Track", aliases: ["track", "track name"] },
  {
    key: "track_number",
    label: "Track #",
    aliases: ["track #", "track#", "track number", "track_number"],
  },
  {
    key: "ad_account_name",
    label: "Ad Account",
    aliases: ["ad account", "ad account name", "account"],
  },
  {
    key: "meta_ad_account_id",
    label: "Ad Account ID",
    aliases: ["ad account id", "ad_account_id", "account id"],
  },
  {
    key: "meta_campaign_id",
    label: "Campaign ID",
    aliases: ["campaign id", "campaign_id"],
  },
  {
    key: "campaign_name",
    label: "Campaign Name",
    aliases: ["campaign name", "campaign", "campaign_name"],
  },
  {
    key: "position",
    label: "Order",
    aliases: ["order", "position", "rotation order"],
  },
];

/** Example rows for the downloadable template: two campaigns, then a track with none. */
export const CTM_IMPORT_SAMPLE = [
  [
    "Seekho",
    "hi",
    "Astrology",
    "astrologybasics",
    "418",
    "OGCreatives",
    "act_741706148705098",
    "120214500000000001",
    "Astro_CBO_1",
    "1",
  ],
  [
    "Seekho",
    "hi",
    "Astrology",
    "astrologybasics",
    "418",
    "OGCreatives",
    "act_741706148705098",
    "120214500000000002",
    "Astro_CBO_2",
    "2",
  ],
  ["Seekho", "hi", "Astrology", "vastutips", "419", "", "", "", "", ""],
];

/** Sheet the nomenclature Excel keeps its import rows on; other files use their first sheet. */
export const CTM_IMPORT_SHEET_NAME = "CSV For import";

/** Track fields in the edit window. */
export const ctmFormDefaultState = {
  app_name: "",
  language: "",
  category: "",
  track: "",
  track_number: "",
};

/** Loaders for the combined upload: checking the file, then saving it. */
export const ctmImportLoadingDefaultState = { checking: false, saving: false };
